import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";

import type { NewsSignalEventDto } from "../../../types/signals";
import { getNewsSignalCategory } from "../../signals/getters/getNewsSignalCategory";
import type { SignalEventType } from "../../signals/types";

import { newsSignalEventTrackingMap } from "./newsSignalEventTrackingMap";

export default function createSignalsEventsTrackingService(track: TrackFn) {
    const trackSignalsEvent = (action: string, name: string) => {
        track("signals", action, name);
    };

    const trackSignalsEventActions = (action: string, name: string) => {
        track("signal actions", action, name);
    };

    const getSignalType = (signalEvent: NewsSignalEventDto): string => {
        const { categories } = signalEvent;
        const subtype = categories[0];

        return newsSignalEventTrackingMap[subtype];
    };

    return {
        trackClickOnArticleLink(signalEvent: NewsSignalEventDto) {
            trackSignalsEvent(
                "read article",
                `news/${getNewsSignalCategory(signalEvent)}/${getSignalType(signalEvent)}`,
            );
        },
        trackClickOnCompanyLink(signalEvent: NewsSignalEventDto) {
            trackSignalsEvent(
                "analyze company",
                `news/${getNewsSignalCategory(signalEvent)}/${getSignalType(signalEvent)}`,
            );
        },
        trackClickOnShowMore(quantity: number) {
            trackSignalsEvent("show more", `show all signals/${quantity}`);
        },
        trackClickOnManageSignals(source: string) {
            trackSignalsEventActions("click signal settings", `open my signals management/${source}`);
        },
        trackClickOnActiveSignalsFilter(type: SignalEventType) {
            trackSignalsEventActions("filter results", `signals filters/${type}`);
        },
        trackClickOnInactiveSignalsFilter(type: SignalEventType) {
            trackSignalsEventActions("add signal", `signals filters/${type}`);
        },
        trackClickOnShowDescription() {
            trackSignalsEvent("show description", "news");
        },
        trackHoverIntentTrend() {
            track("intent signal", "hover intent trend", "intent trend overtime");
        },
    };
}
